import { useQuery } from '@apollo/client';
import { GET_CATEGORY_PROPERTIES } from '@/api/queries/categories.queries';
import { GetCategoryPropertiesResponse } from '@/api/types/categories.types';
import { useCurrentCategory } from '@/hooks/useCurrentCategory/useCurrentCategory';

export const useCategoryProperties = (categoryPath?: string) => {
  const { currentCategory } = useCurrentCategory();
  const {
    data,
    refetch: refetchCategoryProperties,
    loading,
  } = useQuery<GetCategoryPropertiesResponse>(GET_CATEGORY_PROPERTIES, {
    skip: !categoryPath && !currentCategory?.path,
    variables: { path: categoryPath || currentCategory?.path },
    errorPolicy: 'all',
  });

  const { id: categoryId, properties: categoryProperties } =
    data?.category ?? {};

  return {
    categoryId,
    categoryProperties,
    refetchCategoryProperties,
    isCategoriesLoading: loading,
  };
};
